import { DiscountApplicationOrderDto, PriceDto } from '@eurogast/hub-client-typescript';
import { Big } from 'big.js';
import { UnitDefinition } from '@/services/ProductDeserializer';

const ROUND_HALF_UP = 1;

export default abstract class PriceService {
  public static findFinalPrice(price: PriceDto, amount: number | Big, unit: UnitDefinition): Big {
    if (!price) {
      return null;
    }
    const scaledAmount = new Big(amount).mul(this.toRatio(unit));
    const discount = price.attachedDiscount;
    let singlePrice = new Big(price.rawValueString);
    if (discount && discount.applicationOrder === DiscountApplicationOrderDto.SINGLE) {
      singlePrice = singlePrice.mul(discount.discountFactorString).round(2, ROUND_HALF_UP);
    }
    let total = singlePrice.mul(scaledAmount);
    if (discount && discount.applicationOrder === DiscountApplicationOrderDto.TOTAL) {
      total = total.mul(discount.discountFactorString);
    }
    return total.round(2, ROUND_HALF_UP);
  }

  public static findBestBulkPrice?(prices: PriceDto[], actualQuantity: number, unit: UnitDefinition): PriceDto {
    if (!prices || prices.length === 0) {
      return null;
    }
    const relevantPrices = this.filterBulkPrices(prices, actualQuantity, unit);
    let bestPrice: PriceDto = null;
    let bestPriceValue: Big = null;
    for (const candidate of relevantPrices) {
      const candidateValue = this.findFinalPrice(candidate, actualQuantity, unit);
      if (!bestPrice || candidateValue.lt(bestPriceValue)) {
        bestPrice = candidate;
        bestPriceValue = candidateValue;
      }
    }
    return bestPrice;
  }

  private static filterBulkPrices(prices: PriceDto[], actualQuantity: number, unit: UnitDefinition) {
    const scaledQuantity = actualQuantity * this.toRatio(unit);
    return prices.filter((price) => price.minQuantity <= scaledQuantity);
  }

  private static toRatio(unit?: UnitDefinition): number {
    return unit ? unit.ratio : 1;
  }
}
